import { Field } from "formik";
import SelectedCheckMark from "../../assets/svg/SelectedCheckMark";
import { useRef } from "react";
import "./styles.css";
import CustomCheckBoxProps from "../../services/models/customCheckBoxProps.model";

function CustomCheckBox({
  id,
  checkBoxClassName,
  name,
  checked,
  value,
  label,
  customCheckBox,
  onClick,
  manualFieldsChangeOnOptionClick,
  disabled,
}: Readonly<CustomCheckBoxProps>): JSX.Element {
  const radioRef = useRef<any>();

  return (
    <label
      htmlFor={id}
      key={id}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={`mt-3 ${
        !!customCheckBox ? "" : "checkboxContainer"
      } mr-3 block ${checkBoxClassName} ${disabled && "cursor-not-allowed"}`}
    >
      {customCheckBox && (
        <div className="w-[2%]">{checked && <SelectedCheckMark />}</div>
      )}

      <Field
        type="checkbox"
        id={id}
        // ref={radioRef}
        name={name}
        disabled={disabled}
        value={value}
        checked={checked}
        className={`${customCheckBox ? "appearance-none" : ""} ${
          disabled && "cursor-not-allowed"
        } focus:ring-primary text-primary before:content:" "`}
        onClick={
          onClick
            ? onClick
            : manualFieldsChangeOnOptionClick
            ? manualFieldsChangeOnOptionClick
            : null
        }
      />
      <span
        className={`${customCheckBox && "w-[98%]"}`}
        dangerouslySetInnerHTML={{ __html: label ?? "" }}
      />
      {!!checkBoxClassName === false && <span className="checkmark" />}
    </label>
  );
}
export default CustomCheckBox;